import { useMenuStore } from '~/store/menu'
export default ({ $pinia }) => {
  const menuStore = useMenuStore($pinia)
  menuStore.disableMenu()
}
